<template>	   
	<v-container>
	 		<v-card>
	 			<v-card-title primary-title>
	 			  <h4 class="display-1">Seccion del Manual</h4>
	 			</v-card-title>
	 		  <v-card-text>
	 				<v-layout row wrap>
				 	  <v-flex xs6 pa-1>
				 	    <v-text-field
				 	      name="name"
				 	      label="Nombre de la sección"
				 	      id="id"
				 	      solo
				 	      v-model="section.name"
				 	    ></v-text-field>
				 	  </v-flex>
				 	  <v-flex xs6 pa-1>
				 	    <v-text-field
				 	      name="name"
				 	      label="Titulo de la sección"
				 	      id="id"
				 	      solo
				 	      v-model="section.title"
				 	    ></v-text-field>
				 	  </v-flex>
				 	  <v-flex xs6 pa-1>
				 	    <v-text-field
				 	    	solo
				 	      name="icon"
				 	      label="Icono"
				 	      id="id"
				 	      :append-icon="section.icon"
				 	      v-model="section.icon"
				 	    ></v-text-field>
				 	  </v-flex>
				 	  <v-flex xs6 pa-1>
				 	    <v-text-field
				 	    	solo
				 	      name="order_list"
				 	      label="Posicion en la lista"
				 	      id="id"
				 	      v-model="section.list_order"
				 	    ></v-text-field>
				 	  </v-flex>
				 	  <v-flex xs6 pa-1>
				 	    <v-text-field
				 	    	solo
				 	      name="icon"
				 	      label="Idioma"
				 	      id="id"
				 	      v-model="section.lang"				 	      
				 	    ></v-text-field>
				 	  </v-flex>
				 	  <v-flex xs6 pa-1>
				 	    <v-autocomplete
				 	    	:items="roles"
				 	    	multiple
				 	    	solo
				 	      name="role"
				 	      label="Roles"
				 	      id="id"
				 	      v-model="section.roles"				 	      
				 	    ></v-autocomplete>
				 	  </v-flex>
				 	  <v-flex xs12>
				 	    <v-textarea
					      name="text"
					      label="Texto"
					      id="id"
					      solo
					      v-model="section.text"
					    ></v-textarea>
				 	  </v-flex>
				 	</v-layout>
				 	<v-card>
				 		<v-card-title primary-title>
				 		 	<h5 class="title">Items</h5>
				 		 	<v-spacer></v-spacer>
				 		 	<v-btn  color="grey lighten-3" fab small @click="addItem()">
				 		 		<v-icon color="success" >fas fa-plus</v-icon>
				 		 	</v-btn>
				 		</v-card-title>
				 	  <v-card-text style="border: 1px solid #bababa; margin-bottom: 4px;" v-for="item in section.items">
				 	  	<v-card>
				 	  		<v-card-title primary-title>
				 	  			<h5 class="title">{{item.title}}</h5>
				 	  			<v-spacer></v-spacer>
				 	  		  <v-btn  color="grey lighten-3" fab small @click="item.active = !item.active">
						 		 		<v-icon color="grey" >{{!item.active ? 'far fa-square' : 'fas fa-minus'}}</v-icon>
						 		 	</v-btn>
				 	  		</v-card-title>
								<v-layout row wrap v-show="item.active">
								  <v-flex xs6 pa-1>
								    <v-text-field
								      name="Nombre"
								      label="Nombre"
								      id="id"
								      v-model="item.name"
								      solo
								    ></v-text-field>
								  </v-flex>
								  <v-flex xs6>
								    <v-text-field
								      name="title"
								      label="Titulo"
								      id="id"
								      v-model="item.title"
								      solo
								    ></v-text-field>
								  </v-flex>
								  <v-flex xs6 pa-1>
								    <v-text-field
								      name="lang"
								      label="Idioma"
								      id="id"
								      solo
								      v-model="item.lang"
								    ></v-text-field>
								  </v-flex>
								  <v-flex xs6 pa-1>
								    <v-text-field
								      name="list_order"
								      label="Posicion en la lista"
								      id="id"
								      solo
								      v-model="item.list_order"
								    ></v-text-field>
								  </v-flex>
								  <v-flex xs12>
								    <v-textarea
								      name="text"
								      label="Texto"
								      id="id"
								      solo
								      v-model="item.text"
								    ></v-textarea>
								  </v-flex>
								  <v-flex xs12>
								  	<v-card>
								  	  <v-card-title primary-title>
							    			<h4 class="title">Contenidos</h4>
								  	  	<v-spacer></v-spacer>
								  	  	<v-btn color="grey lighten-2" fab small @click="addContent(item)">
													<v-icon color="success">fas fa-plus</v-icon>
								  	  	</v-btn>
								  	  </v-card-title>
								  	  <v-card-text v-for="content in item.contents">
								  	    <v-card>
								  	      <v-card-title primary-title>
								  	        {{ content.title }}
								  	  			<v-spacer></v-spacer>
														<v-btn  color="grey lighten-3" fab small @click="content.active = !content.active">
											 		 		<v-icon color="grey" >{{!content.active ? 'far fa-square' : 'fas fa-minus'}}</v-icon>
											 		 	</v-btn>
								  	      </v-card-title>
								  	      <v-card-text>
								  	        <v-layout row wrap>
								  	          <v-flex xs6 pa-1>
								  	            <v-text-field
								  	            	solo
								  	              name="name"
								  	              label="Nombre"
								  	              id="id"
								  	              v-model="content.name"
								  	            ></v-text-field>
								  	          </v-flex>
								  	          <v-flex xs6 pa-1>
								  	            <v-text-field
								  	            	solo
								  	              name="titulo"
								  	              label="Titulo"
								  	              id="id"	
								  	              v-model="content.title"
								  	            ></v-text-field>
								  	          </v-flex>
								  	          <v-flex xs6 pa-1>
								  	            <v-text-field
								  	            	solo
								  	              name="orden_list"
								  	              label="Orden en la lista"
								  	              id="id"	
								  	              v-model="content.list_order"
								  	            ></v-text-field>
								  	          </v-flex>
								  	          <v-flex xs6 pa-1>
								  	            <v-text-field
								  	            	solo
								  	              name="lang"
								  	              label="Idioma"
								  	              id="lang"	
								  	              v-model="content.lang"
								  	            ></v-text-field>
								  	          </v-flex>
								  	          <v-textarea
								  	          	solo
								  	          	name="content"
							  	          	  label="Contenido"
							  	          	  id="content"
							  	          	  v-model="content.content"
							  	          	></v-textarea>	
								  	        </v-layout>
								  	      </v-card-text>
								  	    </v-card>
								  	  </v-card-text>
								  	</v-card>
								  </v-flex>
								</v-layout>
				 	  	</v-card>
				 	  </v-card-text>
				 	  <v-card-actions>
				 	  	<v-spacer></v-spacer> 
				 	    <v-btn color="success" @click="store()">Guardar</v-btn>
				 	  </v-card-actions>
				 	</v-card>
	 		  </v-card-text>
	 		</v-card>

	 	<v-snackbar
	 	  v-model="alert.active"
	 	>
	 	 {{ alert.message }}
	 	  <v-btn text :color="alert.color" @click.native="alert.active = false">Close</v-btn>
	 	</v-snackbar>
	</v-container>
</template>
<script>
/* eslint-disable */
	export default{
		created() {

		},
		mounted(){
			this.getData();
		},
		props: [
			'auth'
		],
		data(){
			return {
				roles: [
					{text: 'Administrador', value: 1},
					{text: 'Investigador', value: 2},
					{text: 'Visualizador', value: 3},
					{text: 'Invitado', value: 4},
				],
				createCategory: '',
				editCategory: '',
				baseRoute: process.env.VUE_APP_URL + 'api/documentation/settings/',
				modalDelete: {
					active: false,
					data: {}
				},
				alert: {
					active: false,
					message: "",
					color: "success"
				},
				selects: {
					types: [],
					localities: [],
					coor_typ: []
				},
				storeRoute: '',
				selected: [],
				section: {
					name: '',
					title: '',
					list_order: '',
					lang: '',
					items: [
					{
						name: '',
						lang: '',
						list_order: '',
						text: '',
						title: '',
						active: true,
						contents: [{
							name: '',
							title: '',
							type: '',
							content: '',
							list_order: '',
							lang: '',
							active: true,
						}],
					}
				],
				}
			}
		},
		methods: {
			getData(){
				if(this.$route.params.id != null){
					this.storeRoute = 'update';
					axios.get(this.baseRoute + 'edit?id=' + this.$route.params.id).then((res) => {
						if(res.data == "Error"){
							this.alert.active = true;
							this.alert.message = "Impsoble traer los datos";
							this.alert.color = "error";
						}else{
							this.section = res.data;
						}
					}).catch((error) => {
						this.alert.active = true;
						this.alert.message = "Hubó un error interno en el servidor contacte con el desarrollador";
						this.alert.color = "error";
						this.table.loading = false;
					});
				}else{
					this.storeRoute = 'store';
				}
			},
			addItem(){
				this.section.items.push({
					name: '',
					lang: '',
					list_order: '',
					text: '',
					title: '',
					active: true,
					contents: []
				})
			},
			addContent(item){
				item.contents.push({
					name: '',
					title: '',
					type: '',
					content: '',
					list_order: '',
					lang: '',
					active: true,
				})
			},
			store(){{
				axios.post(this.baseRoute + this.storeRoute, this.section).then((res) => {
					if(res.data == 'Exito'){
						this.alert.active = true;
						this.alert.message = 'Registro Guardado exitosamente :)';
						this.alert.color = 'success';
					}
				}).catch((error) => {
					this.alert.active = true;
					this.alert.message = 'Hubo un error Inesperado';
					this.alert.color = 'error';
				})
			}}
		},
		watch: {

		},
		computed: {

		},
	}
/* eslint-enable */
</script>